var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-2"},[_c('b-tooltip',{attrs:{"label":_vm.label,"position":"is-bottom"}},[_c('b-icon',{attrs:{"icon":_vm.icon}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }